var _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeaderBackgroundSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    preserveAspectRatio: "none",
    viewBox: "0 0 1920 601",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1920 479.507L1846.13 487.433C1770.03 495.359 1622.3 511.211 1472.33 463.655C1322.36 416.1 1182.47 328.988 1032.5 321.062C882.532 313.137 726.968 384.396 577 408.174C427.032 431.951 279.302 384.396 129.333 384.396C-20.6351 384.396 -168.365 431.951 -318.333 463.655C-468.302 495.359 -616.032 511.211 -692.135 519.137L-766 527.062V99.0625H-692.135C-616.032 99.0625 -468.302 99.0625 -318.333 99.0625C-168.365 99.0625 -20.6351 99.0625 129.333 99.0625C279.302 99.0625 427.032 99.0625 577 99.0625C726.968 99.0625 874.698 99.0625 1024.67 99.0625C1174.63 99.0625 1322.36 99.0625 1472.33 99.0625C1622.3 99.0625 1770.03 99.0625 1846.13 99.0625H1920V479.507Z",
    fill: "#C3E9F1",
    fillOpacity: 0.31
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-4.99963 319.807L59.0681 337.725C123.136 355.642 252.364 421.244 380.5 412.757C507.618 403.326 622.458 374.548 750.594 338.712C878.729 302.876 1127.36 242.061 1255.5 304.302C1382.62 367.487 1405.46 376.918 1533.59 430.672C1661.73 484.426 1789.86 448.59 1853.93 430.672L1918 412.754L1918 379.332L1853.93 397.25C1789.86 415.168 1661.73 451.004 1533.59 397.25C1405.46 343.496 1382.62 334.065 1255.5 270.88C1127.36 208.639 878.729 269.454 750.593 305.29C622.457 341.125 507.618 369.904 380.5 379.334C252.364 387.822 123.136 322.22 59.0678 304.302L-5 286.384L-4.99963 319.807Z",
    fill: "#C3E9F1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.14843e-05 308.69L50.0697 325.079C114.137 341.467 243.366 401.47 371.501 393.707C498.62 385.081 613.459 358.759 741.595 325.982C914.502 287.658 1173.5 265.954 1355.5 338.162C1486.05 389.955 1407.46 360.929 1535.59 410.095C1663.73 459.261 1791.86 426.484 1855.93 410.095L1920 393.707V-450.938H1855.93C1791.86 -450.938 1663.73 -450.938 1535.59 -450.938C1407.46 -450.938 1279.32 -450.938 1152.2 -450.938C1024.07 -450.938 895.932 -450.938 767.797 -450.938C639.661 -450.938 511.526 -450.938 384.407 -450.938C256.271 -450.938 128.136 -450.938 64.0678 -450.938H0L4.14843e-05 308.69Z",
    fill: "url(#paint0_linear_2626_2540)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.14843e-05 308.69L50.0697 325.079C114.137 341.467 243.366 401.47 371.501 393.707C498.62 385.081 613.459 358.759 741.595 325.982C914.502 287.658 1173.5 265.954 1355.5 338.162C1486.05 389.955 1407.46 360.929 1535.59 410.095C1663.73 459.261 1791.86 426.484 1855.93 410.095L1920 393.707V-450.938H1855.93C1791.86 -450.938 1663.73 -450.938 1535.59 -450.938C1407.46 -450.938 1279.32 -450.938 1152.2 -450.938C1024.07 -450.938 895.932 -450.938 767.797 -450.938C639.661 -450.938 511.526 -450.938 384.407 -450.938C256.271 -450.938 128.136 -450.938 64.0678 -450.938H0L4.14843e-05 308.69Z",
    fill: "url(#paint1_linear_2626_2540)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 19.7598L52.8 29.3268C107.2 38.8939 212.8 58.0279 320 58.0279C427.2 58.0279 532.8 38.8939 640 29.3268C747.2 19.7598 852.8 19.7598 960 48.4609C1067.2 77.162 1172.8 134.564 1280 163.265C1387.2 191.967 1492.8 191.967 1600 182.4C1707.2 172.832 1812.8 153.698 1867.2 144.131L1920 134.564V364.173H1867.2C1812.8 364.173 1707.2 364.173 1600 364.173C1492.8 364.173 1387.2 364.173 1280 364.173C1172.8 364.173 1067.2 364.173 960 364.173C852.8 364.173 747.2 364.173 640 364.173C532.8 364.173 427.2 364.173 320 364.173C212.8 364.173 107.2 364.173 52.8 364.173H0V19.7598Z",
    fill: "url(#paint2_linear_2626_2540)",
    fillOpacity: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-549 -311.908L-462.2 -263.033C-375.4 -214.158 -201.8 -116.408 -28.2 -126.183C145.4 -135.958 319 -253.258 492.6 -282.583C666.2 -311.908 839.8 -253.258 1013.4 -214.158C1187 -175.058 1360.6 -155.508 1534.2 -184.833C1707.8 -214.158 1881.4 -292.358 1968.2 -331.458L2055 -370.559V98.6425H1968.2C1881.4 98.6425 1707.8 98.6425 1534.2 98.6425C1360.6 98.6425 1187 98.6425 1013.4 98.6425C839.8 98.6425 666.2 98.6425 492.6 98.6425C319 98.6425 145.4 98.6425 -28.2 98.6425C-201.8 98.6425 -375.4 98.6425 -462.2 98.6425H-549V-311.908Z",
    fill: "url(#paint3_linear_2626_2540)",
    fillOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2626_2540",
    x1: 960.001,
    y1: -414.531,
    x2: 960.001,
    y2: 710.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.130556,
    stopColor: "#002A7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.689869,
    stopColor: "#009ABB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933485,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2626_2540",
    x1: 960,
    y1: 436.063,
    x2: 960,
    y2: -450.937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00095F",
    stopOpacity: 0.29
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2626_2540",
    x1: 960,
    y1: 19.7598,
    x2: 960,
    y2: 364.173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60E3FF",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0099FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2626_2540",
    x1: 753,
    y1: -370.559,
    x2: 753,
    y2: 98.6425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0090FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0099FF",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderBackgroundSmall);
export default __webpack_public_path__ + "static/media/header_background_small.247ce5a94d5f342fafb82f88d520912d.svg";
export { ForwardRef as ReactComponent };